/*eslint-disable */
//Conflict between Prettier and eslint regarding the error Missing parentheses around multilines JSX  react/jsx-wrap-multilines
import React, { FC, memo, useCallback } from "react";
import { createUseStyles } from "react-jss";

import styles from "./styles";
import SearchOptions from "Components/SearchOptions";
import { setCurrentView } from "Containers/MapSwitcher/mapSwitcher.Actions";
import { areEqual, areEqualShallow } from "Utils/areEqual";
import Icon from "Components/Icons";
import { useDispatch, useSelector } from "react-redux";

interface Props {
  resetTrails: () => void;
  goToDestinations: () => void;
  goToCampusMap: () => void;
  showSwitcher: boolean;
  usedSwitcher: boolean;
  setShowTrails: (showTrails: boolean) => void;
  showTrails: boolean;
  setSearchOptionsView: (
    view: string,
    showSearchOptionsMobile?: boolean
  ) => void;
  showDefaultMobileSearchOptions: boolean;
  setShowDefaultMobileSearchOptions: (status: boolean) => void;
  selectedTrail: string;
}
const SearchOptionsDestinations: FC<Props> = memo(
  ({
    resetTrails,
    goToDestinations,
    goToCampusMap,
    usedSwitcher,
    setShowTrails,
    showTrails, //Default to no stops
    setSearchOptionsView,
    showDefaultMobileSearchOptions,
    setShowDefaultMobileSearchOptions,
    selectedTrail,
    showSwitcher,
  }: Props) => {
    const useStyles = createUseStyles(styles);
    const classes = useStyles();
    const dispatch = useDispatch();
    const view = useSelector((store: any) => store.searchOptionsView.view);
    const currentView = useSelector(
      (store: any) => store.mapSwitcher.currentView
    );
    const { modules } = useSelector(
      (selectors: any) => selectors.locationModulesMatrix,
      areEqual
    );
    const { platform, originalSource } = useSelector(
      (store: any) => store.tour
    );
    const directionsModule = modules?.filter((obj) => {
      return obj.moduleid === "directions";
    })[0];

    const showDirectionsModule = () => {
      let correctPlatform;
      if (platform === "w") correctPlatform = "web";
      if (platform === "v") correctPlatform = "vhost";
      if (!platform) correctPlatform = originalSource;
      return directionsModule[correctPlatform] === "1" ? true : false;
    };
    const gotToDirections = useCallback(() => {
      if (currentView === "campusmap")
        dispatch(setCurrentView("mapview", false));
      resetTrails();
      setSearchOptionsView("directions"); //I want searchOptionsView to be true
    }, [setSearchOptionsView, currentView]);

    const currentLabelClick = useCallback(() => {
      setShowTrails(!showTrails);
    }, [showTrails]);


    //DesktopView
    return (
      <>
      {
        view === "trails" && (
          <SearchOptions
        showTrails={showTrails}
        arrowSlot={
          <div className={!showTrails && classes.hideMobileLandscape}>
            <Icon
              type={"leftarrow"}
              events={{
                onClick:
                  usedSwitcher || !showSwitcher
                    ? goToDestinations
                    : goToCampusMap,
              }}
            />
          </div>
        }
        key={`showDestinations-desktop-trails`}
        slot1={<Icon type={"trails"} tabIndex={-1} />}
        textLabel={
          <Icon
            text={selectedTrail ? selectedTrail : "Trails"}
            type={"textLabel"}
            events={{ onClick: currentLabelClick }}
            className={`${classes.button}`}
          />
        }
        slot2={
          directionsModule &&
          showDirectionsModule() && (
            <div className={!showTrails && classes.hideMobileLandscape}>
              <Icon type={"directions"} events={{ onClick: gotToDirections }} />
            </div>
          )
        }
        slot3={
          <div className={!showTrails && classes.hideMobileLandscape}>
            <Icon
              type={"close"}
              events={{
                onClick:
                  usedSwitcher || !showSwitcher
                    ? goToDestinations
                    : goToCampusMap,
              }}
            />
          </div>
        }
      />
        )
      }
    </>
    );
  },
  areEqualShallow
);

export default SearchOptionsDestinations;
try {
    // @ts-ignore
    SearchOptionsTrails.displayName = "SearchOptionsTrails";
    // @ts-ignore
    SearchOptionsTrails.__docgenInfo = { "description": "", "displayName": "SearchOptionsTrails", "props": { "resetTrails": { "defaultValue": null, "description": "", "name": "resetTrails", "required": true, "type": { "name": "() => void" } }, "goToDestinations": { "defaultValue": null, "description": "", "name": "goToDestinations", "required": true, "type": { "name": "() => void" } }, "goToCampusMap": { "defaultValue": null, "description": "", "name": "goToCampusMap", "required": true, "type": { "name": "() => void" } }, "showSwitcher": { "defaultValue": null, "description": "", "name": "showSwitcher", "required": true, "type": { "name": "boolean" } }, "usedSwitcher": { "defaultValue": null, "description": "", "name": "usedSwitcher", "required": true, "type": { "name": "boolean" } }, "setShowTrails": { "defaultValue": null, "description": "", "name": "setShowTrails", "required": true, "type": { "name": "(showTrails: boolean) => void" } }, "showTrails": { "defaultValue": null, "description": "", "name": "showTrails", "required": true, "type": { "name": "boolean" } }, "setSearchOptionsView": { "defaultValue": null, "description": "", "name": "setSearchOptionsView", "required": true, "type": { "name": "(view: string, showSearchOptionsMobile?: boolean) => void" } }, "showDefaultMobileSearchOptions": { "defaultValue": null, "description": "", "name": "showDefaultMobileSearchOptions", "required": true, "type": { "name": "boolean" } }, "setShowDefaultMobileSearchOptions": { "defaultValue": null, "description": "", "name": "setShowDefaultMobileSearchOptions", "required": true, "type": { "name": "(status: boolean) => void" } }, "selectedTrail": { "defaultValue": null, "description": "", "name": "selectedTrail", "required": true, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Trails/SearchOptionsTrails.tsx#SearchOptionsTrails"] = { docgenInfo: SearchOptionsTrails.__docgenInfo, name: "SearchOptionsTrails", path: "src/shared/components/Trails/SearchOptionsTrails.tsx#SearchOptionsTrails" };
}
catch (__react_docgen_typescript_loader_error) { }